import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { INICIA_TURMA, SALVA_TURMA, ATUALIZA_TURMA, BUSCA_TURMA_EDICAO, REMOVE_TURMA, LISTA_TURMA, ON_HIDE_LOADER, LISTA_CURSOS_POR_ESCOLA_TURMA, LISTA_SERIES_POR_CURSO_TURMA, LISTA_ESCOLAS_TURMA, LISTA_ESCOLAS_TURMA_SUCESSO, LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA, GET_DISCIPLINAS_TURMA } from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import { showAuthMessage } from "actions/Turma";
import { salvaTurmaSucesso, removeTurmaSucesso, inicioTurmaSucesso, buscaTurmaEdicaoSucesso, listaTurmaSucesso, listaCursosPorEscolaTurmaSucesso, listaSeriesPorCursoTurmaSucesso, listaEscolasTurmaSucesso, listaAnosLetivosPorEscolaTurmaSucesso, getDisciplinasTurmaSuccess } from "actions/Turma";

const toNumberOrNull = (v) => {
  if (v === undefined || v === null || v === '') return null;
  if (typeof v === 'number') return Number.isNaN(v) ? null : v;
  if (typeof v === 'string') {
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
  }
  if (typeof v === 'boolean') return v ? 1 : 0;
  if (typeof v === 'object') {
    const cand = v.id ?? v.value ?? v.valor;
    if (cand === undefined || cand === null) return null;
    return toNumberOrNull(cand);
  }
  return null;
};

const extractIdNumber = (v) => {
  if (v === undefined || v === null || v === '') return null;
  if (typeof v === 'object') {
    if (typeof v.value === 'object') return toNumberOrNull(v.value.id ?? v.value.value ?? v.value);
    return toNumberOrNull(v.id ?? v.value ?? v);
  }
  return toNumberOrNull(v);
};

const normalizeDiasSemana = (ds) => {
  if (!ds) return [];
  if (Array.isArray(ds)) return ds;
  if (typeof ds === 'string') {
    try {
      const parsed = JSON.parse(ds);
      return Array.isArray(parsed) ? parsed : [ds];
    } catch (e) {
      return ds.includes(',') ? ds.split(',').map(s => s.trim()) : [ds];
    }
  }
  return [];
};

const ensureHoraComSegundos = (v) => {
  if (v === undefined || v === null) return '';
  const s = String(v).trim();
  const parts = s.split(':').map(p => p.trim()).filter(p => p.length > 0);
  const pad = (x) => {
    const n = String(x || '0');
    const d = n.replace(/[^0-9]/g, '');
    return d.length === 1 ? ('0' + d) : (d.length >= 2 ? d.slice(-2) : '00');
  };
  if (parts.length >= 3) {
    return `${pad(parts[0])}:${pad(parts[1])}:${pad(parts[2])}`;
  }
  if (parts.length === 2) {
    return `${pad(parts[0])}:${pad(parts[1])}:00`;
  }
  if (parts.length === 1) {
    return `${pad(parts[0])}:00:00`;
  }
  return '';
};

const normalizeMediacaoTipo = (v) => {
  if (v === undefined || v === null) return null;
  if (typeof v === 'string') return v; // já é "Presencial", "Semipresencial" ou "Educação a distância"
  const id = (typeof v === 'object') ? (v.id ?? v.value ?? v) : v;
  switch (Number(id)) {
    case 1: return 'Presencial';
    case 2: return 'Semipresencial';
    case 3: return 'Educação a distância';
    default: return null;
  }
};

const getIdClienteFromPayload = (p) => {
  const direto = p?.idCliente ?? p?.IdCliente;
  if (direto !== undefined && direto !== null) return toNumberOrNull(direto);
  try {
    if (typeof localStorage !== 'undefined') {
      const fixado = localStorage.getItem('idClienteFixado');
      return toNumberOrNull(fixado);
    }
  } catch (e) {}
  return null;
};

const normalizeTurmaPayload = (p) => {
  if (!p || typeof p !== 'object') return p;
  const out = {};
  out.Id = toNumberOrNull(p.Id ?? p.id);
  out.idCliente = getIdClienteFromPayload(p);
  out.Ano = toNumberOrNull(p.Ano ?? p.ano);
  out.EscolaId = extractIdNumber(p.EscolaId ?? p.escolaId ?? p.escola_id);
  out.CursoId = extractIdNumber(p.CursoId ?? p.cursoId ?? p.curso_id);
  out.SerieId = extractIdNumber(p.SerieId ?? p.serieId ?? p.serie_id);
  out.ProfessorId = extractIdNumber(p.ProfessorId ?? p.professorId ?? p.professor_id);
  out.TurmaTipoId = extractIdNumber(p.TurmaTipoId ?? p.turmaTipoId ?? p.turma_tipo_id);
  out.Nome = p.Nome ?? p.nome ?? '';
  out.Sigla = p.Sigla ?? p.sigla ?? '';
  out.MaxAluno = toNumberOrNull(p.MaxAluno ?? p.maxAluno);
  out.EstaAtiva = !!(p.EstaAtiva ?? p.estaAtiva ?? p.ativo);
  out.MediacaoTipo = normalizeMediacaoTipo(p.MediacaoTipo ?? p.mediacaoTipo);
  out.HoraInicial = ensureHoraComSegundos(p.HoraInicial ?? p.horaInicial ?? '');
  out.HoraInicioIntervalo = ensureHoraComSegundos(p.HoraInicioIntervalo ?? p.horaInicioIntervalo ?? '');
  out.HoraFimIntervalo = ensureHoraComSegundos(p.HoraFimIntervalo ?? p.horaFimIntervalo ?? '');
  out.HoraFinal = ensureHoraComSegundos(p.HoraFinal ?? p.horaFinal ?? '');
  const diasRaw = p.DiasSemana ?? p.diasSemana ?? p.dias_semana;
  out.DiasSemana = normalizeDiasSemana(diasRaw);
  out.Turno = p.Turno ?? p.turno ?? null;
  const tb = p.TipoBoletim ?? p.tipoBoletim;
  if (tb === undefined || tb === null || tb === '') {
    out.TipoBoletim = null;
  } else if (typeof tb === 'string') {
    out.TipoBoletim = tb;
  } else if (typeof tb === 'object') {
    const val = tb.id ?? tb.value ?? null;
    out.TipoBoletim = val === null ? null : String(val);
  } else {
    out.TipoBoletim = String(tb);
  }
  out.MultiProfessor = !!(p.MultiProfessor ?? p.multiProfessor);
  const profs = p.Professores ?? p.professores;
  out.Professores = Array.isArray(profs) ? profs : [];
  return out;
};

const normalizeListaTurmas = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.turma)) return data.turma;
  if (data && Array.isArray(data.Turma)) return data.Turma;
  if (data && Array.isArray(data.turmas)) return data.turmas;
  if (data && Array.isArray(data.Turmas)) return data.Turmas;
  if (data && typeof data === 'object') return [data];
  return [];
};

const normalizeFiltro = (f) => {
  const out = {};
  const toParam = (v) => {
    if (v === undefined || v === null) return undefined;
    const n = Number(v);
    if (isFinite(n)) return n === 0 ? undefined : n;
    return v;
  };
  out.EscolaId = toParam(f.EscolaId || f.escolaId);
  out.CursoId = toParam(f.CursoId || f.cursoId);
  out.SerieId = toParam(f.SerieId || f.serieId);
  out.Ano = toParam(f.AnoLetivo || f.anoLetivo || f.Ano || f.ano);
  const nome = f.nome || f.Nome || f.Texto || undefined;
  if (nome) out.Nome = nome;
  return out;
};

const getTurmas = async () =>
  await requisicaoApi.get('/turmas')
    .then(resposta => resposta)
    .catch(error => error);

const getEscolas = async () =>
  await requisicaoApi.get('/escolas')
    .then(resposta => resposta)
    .catch(error => error);

const getTurmaEdicao = async (id) =>
  await requisicaoApi.get('/turmas/' + id)
    .then(resposta => resposta)
    .catch(error => error);

const getListaTurma = async (filtros) => {
  let params = {};
  if (typeof filtros === 'string') {
    params.Nome = filtros;
  } else if (filtros) {
    params = normalizeFiltro(filtros);
  }

  return await requisicaoApi.get('/turmas', { params })
    .then(resposta => resposta)
    .catch(error => error);
};

const adicionaTurmaRequest = async (turma) =>
  await requisicaoApi.post('/turmas', turma)
    .then(resposta => resposta)
    .catch(error => error);

const atualizaTurmaRequest = async (turma) =>
  await requisicaoApi.put('/turmas/' + (turma.id || turma.Id || ''), turma)
    .then(resposta => resposta)
    .catch(error => error);

const deleteTurmaRequest = async (id) =>
  await requisicaoApi.delete('/turmas/' + id)
    .then(resposta => resposta)
    .catch(error => error);

  const getCursosDaEscola = async (idEscola) =>
  await requisicaoApi.get(`/escolas/${idEscola}/cursos`)
    .then(resposta => resposta)
    .catch(error => error);

const getAnosLetivosPorEscola = async (idEscola) =>
  await requisicaoApi.get(`/escolas/${idEscola}/anos-letivos`)
    .then(resposta => resposta)
    .catch(error => error);

const getSeriesPorCurso = async (cursoId) =>
  await requisicaoApi.get('/series', { params: { CursoId: cursoId } })
    .then(resposta => resposta)
    .catch(error => error);

const getTodosCursos = async () =>
  await requisicaoApi.get('/cursos')
    .then(resposta => resposta)
    .catch(error => error);

const getDisciplinasDisponiveis = async (escolaId, serieId, ano) => {
  // Busca disciplinas disponíveis para a turma usando o endpoint correto
  return await requisicaoApi.get('/turmas/disciplinas-disponiveis', { params: { escolaId, serieId, ano } })
    .then(resposta => resposta)
    .catch(error => error);
};

function* fnIniciaTurma() {
  try {
    const [retTurmas, retEscolas] = yield all([
      call(getTurmas),
      call(getEscolas)
    ]);
    if (retTurmas.message) {
      yield put(showAuthMessage(JSON.stringify(retTurmas.message)));
    } else {
      const listaNormalizada = normalizeListaTurmas(retTurmas.data);
      yield put(inicioTurmaSucesso(listaNormalizada));
    }
    if (!retEscolas.message && retEscolas.data) {
      const escolasData = retEscolas.data;
      yield put({ type: LISTA_ESCOLAS_TURMA_SUCESSO, payload: { escolas: escolasData } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnBuscaTurmaEdicao({ payload }) {
  try {
    const retorno = yield call(getTurmaEdicao, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const turma = retorno.data || {};
      yield put(buscaTurmaEdicaoSucesso(turma));
      const escolaId = turma.escolaId || turma.EscolaId || turma.escola_id;
      if (escolaId) {
        const retCursos = yield call(getCursosDaEscola, escolaId);
        if (!retCursos.message && retCursos.data) {
          const data = retCursos.data;
          let listaCursos = Array.isArray(data) ? data : (Array.isArray(data?.cursos) ? data.cursos : (Array.isArray(data?.Cursos) ? data.Cursos : []));
          const precisaEnriquecer = Array.isArray(listaCursos) && listaCursos.some(item => {
            if (typeof item !== 'object') return true;
            const nome = item.nome || item.Nome || item.descricao || item.Descricao || item.titulo || item.Titulo || item.nomeCurso || item.NomeCurso || item.descricaoCurso || item.DescricaoCurso;
            return !nome;
          });
          if (precisaEnriquecer) {
            const retTodos = yield call(getTodosCursos);
            if (!retTodos.message && retTodos.data) {
              const todosRaw = retTodos.data;
              const todos = Array.isArray(todosRaw) ? todosRaw : (Array.isArray(todosRaw?.curso) ? todosRaw.curso : (Array.isArray(todosRaw?.Curso) ? todosRaw.Curso : []));
              const mapa = new Map(todos.map(c => [ (c.id || c.Id), (c.nome || c.Nome || c.descricao || c.Descricao) ]));
              listaCursos = listaCursos.map(item => {
                if (typeof item === 'object') {
                  const temNome = !!(item.nome || item.Nome || item.descricao || item.Descricao || item.titulo || item.Titulo || item.nomeCurso || item.NomeCurso || item.descricaoCurso || item.DescricaoCurso);
                  if (temNome) return item;
                  const idVal = item.id || item.Id || item.cursoId || item.CursoId;
                  const nome = mapa.get(idVal) || String(idVal || '');
                  return { ...item, id: idVal, nome };
                }
                const nome = mapa.get(item) || String(item);
                return { id: item, nome };
              });
            }
          }
          yield put(listaCursosPorEscolaTurmaSucesso(listaCursos));
        }
        try {
          const retAnos = yield call(getAnosLetivosPorEscola, escolaId);
          if (!retAnos.message && retAnos.data) {
            const dataAnos = retAnos.data;
          const listaAnos = Array.isArray(dataAnos)
            ? dataAnos
            : (Array.isArray(dataAnos?.anosLetivosAtivos) ? dataAnos.anosLetivosAtivos
              : (Array.isArray(dataAnos?.anosLetivos) ? dataAnos.anosLetivos
                : (Array.isArray(dataAnos?.ativos) ? dataAnos.ativos : [])));
          yield put(listaAnosLetivosPorEscolaTurmaSucesso(listaAnos));
            const len = Array.isArray(listaAnos) ? listaAnos.length : 0;
            if (len === 0) {
              yield put(showAuthMessage('A escola precisa ter um ano letivo iniciado.'));
            }
          }
        } catch(_e) {}
      }
      const cursoId = turma.cursoId || turma.CursoId || turma.curso_id;
      if (cursoId) {
        const retSeries = yield call(getSeriesPorCurso, cursoId);
        if (!retSeries.message && retSeries.data) {
          const data = retSeries.data;
          const listaSeries = Array.isArray(data) ? data : (Array.isArray(data?.series) ? data.series : (Array.isArray(data?.Series) ? data.Series : []));
          yield put(listaSeriesPorCursoTurmaSucesso(listaSeries));
        }
      }
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaTurma({ payload }) {
  try {
    const filtros = normalizeFiltro(payload || {});
    const retorno = yield call(getListaTurma, filtros);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const listaNormalizada = normalizeListaTurmas(retorno.data);
      yield put(listaTurmaSucesso(listaNormalizada));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnListaEscolasTurma() {
  try {
    const retorno = yield call(getEscolas);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(listaEscolasTurmaSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnSalvaTurma({ payload }) {
  try {
    const payloadNormalized = normalizeTurmaPayload(payload);
    const retorno = yield call(adicionaTurmaRequest, payloadNormalized);
    if (retorno.message) {
      const status = retorno?.response?.status;
      const data = retorno?.response?.data;
      if (status === 400) {
        let mensagemValidacao = '';
        let inconsistencias = data?.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
          mensagemValidacao = inconsistencias[0].mensagem;
        } else if (data && typeof data === 'object') {
          mensagemValidacao = data.mensagem || JSON.stringify(data);
        }
        yield put(showAuthMessage(mensagemValidacao || retorno.message));
      } else {
        yield put(showAuthMessage(JSON.stringify(retorno.message)));
      }
    } else {
      yield put(salvaTurmaSucesso('Turma salva com sucesso!'));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnAtualizaTurma({ payload }) {
  try {
    const payloadNormalized = normalizeTurmaPayload(payload);
    const retorno = yield call(atualizaTurmaRequest, payloadNormalized);
    if (retorno.message) {
      const status = retorno?.response?.status;
      const data = retorno?.response?.data;
      if (status === 400) {
        let mensagemValidacao = '';
        let inconsistencias = data?.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
          mensagemValidacao = inconsistencias[0].mensagem;
        } else if (data && typeof data === 'object') {
          mensagemValidacao = data.mensagem || JSON.stringify(data);
        }
        yield put(showAuthMessage(mensagemValidacao || retorno.message));
      } else {
        yield put(showAuthMessage(JSON.stringify(retorno.message)));
      }
    } else {
      yield put(salvaTurmaSucesso('Turma atualizada com sucesso!'));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnRemoveTurma({ payload }) {
  try {
    const retorno = yield call(deleteTurmaRequest, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(removeTurmaSucesso('Turma removida com sucesso!'));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaCursosPorEscolaTurma({ payload }) {
  try {
    const escolaId = payload?.escolaId || 0;
    if (!escolaId || Number(escolaId) === 0) {
      yield put(listaCursosPorEscolaTurmaSucesso([]));
      return;
    }
    const retorno = yield call(getCursosDaEscola, escolaId);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      let lista = Array.isArray(data) ? data : (Array.isArray(data?.cursos) ? data.cursos : (Array.isArray(data?.Cursos) ? data.Cursos : []));
      
      const listaNormalizada = lista.map(c => ({
        id: c.cursoId || c.id || c.Id,
        nome: c.cursoNome || c.nome || c.Nome || c.descricao || c.Descricao || c.titulo || c.Titulo || c.nomeCurso || c.NomeCurso
      }));

      yield put(listaCursosPorEscolaTurmaSucesso(listaNormalizada));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaSeriesPorCursoTurma({ payload }) {
  try {
    const cursoId = payload?.cursoId || 0;
    if (!cursoId || Number(cursoId) === 0) {
      yield put(listaSeriesPorCursoTurmaSucesso([]));
      return;
    }
    const retorno = yield call(getSeriesPorCurso, cursoId);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (Array.isArray(data?.series) ? data.series : (Array.isArray(data?.Series) ? data.Series : []));
      
      const listaNormalizada = lista.map(s => ({
        id: s.serieId || s.id || s.Id,
        nome: s.serieNome || s.nome || s.Nome || s.descricao || s.Descricao
      }));

      yield put(listaSeriesPorCursoTurmaSucesso(listaNormalizada));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

export function* iniciaAcoesTurma() {
  yield takeEvery(INICIA_TURMA, fnIniciaTurma);
}

export function* salvaTurma() {
  yield takeEvery(SALVA_TURMA, fnSalvaTurma);
}

export function* atualizaTurma() {
  yield takeEvery(ATUALIZA_TURMA, fnAtualizaTurma);
}

export function* buscaTurmaEdicao() {
  yield takeEvery(BUSCA_TURMA_EDICAO, fnBuscaTurmaEdicao);
}

export function* removeTurma() {
  yield takeEvery(REMOVE_TURMA, fnRemoveTurma);
}

export function* listaTurma() {
  yield takeEvery(LISTA_TURMA, fnListaTurma);
}

export function* listaCursosPorEscolaTurma() {
  yield takeEvery(LISTA_CURSOS_POR_ESCOLA_TURMA, fnListaCursosPorEscolaTurma);
}

export function* listaSeriesPorCursoTurma() {
  yield takeEvery(LISTA_SERIES_POR_CURSO_TURMA, fnListaSeriesPorCursoTurma);
}

export function* listaEscolasTurma() {
  yield takeEvery(LISTA_ESCOLAS_TURMA, fnListaEscolasTurma);
}

function* fnListaAnosLetivosPorEscolaTurma({ payload }) {
  try {
    const escolaId = payload?.escolaId || 0;
    if (!escolaId || Number(escolaId) === 0) {
      yield put(listaAnosLetivosPorEscolaTurmaSucesso([]));
      return;
    }
    const retorno = yield call(getAnosLetivosPorEscola, escolaId);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      const lista = Array.isArray(data)
        ? data
        : (Array.isArray(data?.anosLetivosAtivos) ? data.anosLetivosAtivos
          : (Array.isArray(data?.anosLetivos) ? data.anosLetivos
            : (Array.isArray(data?.ativos) ? data.ativos : [])));
      yield put(listaAnosLetivosPorEscolaTurmaSucesso(lista));
      const len = Array.isArray(lista) ? lista.length : 0;
      if (len === 0) {
        yield put(showAuthMessage('A escola precisa ter um ano letivo iniciado.'));
      }
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnGetDisciplinasTurma({ payload }) {
  try {
    const { escolaId, serieId, ano } = payload;
    const retorno = yield call(getDisciplinasDisponiveis, escolaId, serieId, ano);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const rawData = retorno.data;
      const data = Array.isArray(rawData) ? rawData : (rawData && rawData.componentes ? rawData.componentes : []);
      
      if (data.length === 0) {
        yield put(showAuthMessage('Não há disciplinas disponíveis para a série e ano selecionados.'));
      }
      
      yield put(getDisciplinasTurmaSuccess(data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

export default function* rootSaga() {
  yield all([
    fork(iniciaAcoesTurma),
    fork(salvaTurma),
    fork(atualizaTurma),
    fork(buscaTurmaEdicao),
    fork(removeTurma),
    fork(listaTurma),
    fork(listaEscolasTurma),
    fork(listaCursosPorEscolaTurma),
    fork(listaSeriesPorCursoTurma),
    fork(function*() { yield takeEvery(LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA, fnListaAnosLetivosPorEscolaTurma); }),
    fork(function*() { yield takeEvery(GET_DISCIPLINAS_TURMA, fnGetDisciplinasTurma); }),
  ]);
}
